module.exports = __webpack_public_path__ + "static/img/10.8e2745c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/7/1/eng/10.png
// module id = NJg+
// module chunks = 0